import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AppForm, DynamicFormContainer } from "../../../../components";
import { DisplaySpinnerContext, FormContextProvider, TabPanelContext } from "../../../../context/ContextIndex";
import { getPezodeRangeSchema, getPezodeRangeDefaultValue } from "../../pezode-range/create/schema";
import { selectSessionConfig } from "../../../../store/store-selector";
import { useSelector } from "react-redux";
import { useFetchListData } from "../../../../hooks/useFetchListData";

const PezodeRangeCreate = ({ onSubmit, onCancel }) => {
  const { t } = useTranslation();

  const spinnerCtx = useContext(DisplaySpinnerContext);
  const settingsConfig = useSelector(selectSessionConfig);
  const _tabContextObject = useContext(TabPanelContext);
  const _tabContext = _tabContextObject.getTabFormContext();

  const [formData, setFormData] = useState({
    pezodeRangeSchema: getPezodeRangeSchema({outputUnitList : []}),
    appformdata: null,
  });

  const selectedPezode = _tabContext.data?.selectedPezodeRange;
  const existingRanges = _tabContext?.data?.pezoderange ? _tabContext?.data?.pezoderange : [];

  const _formattedRange = existingRanges
    .filter((item) => !selectedPezode || item.id !== selectedPezode.id)
    .map((item) => ({
      startRange: parseFloat(item.MininumInputValue),
      endRange: parseFloat(item.MaximumInputValue),
    }));

  const OutputUnitList = useFetchListData(settingsConfig.businessCode, settingsConfig.countryCode, "getPezodeUnit", "pezodeunit");

  const defaultFormValues = selectedPezode
    ? selectedPezode // If editing, use selected pezode. Using record response here because we need the data for listbox
    : getPezodeRangeDefaultValue();

  const onPezodeRangeSubmit = (data) => {
    const newRange = {
      ...data,
      id: selectedPezode ? selectedPezode.id : _tabContext.data?.pezoderange?.length || 0,
      PezodeRangeId: selectedPezode ? selectedPezode.PezodeRangeId : null
    };

    _tabContextObject.setTabFormContext({
      data: {
        ..._tabContext.data,
        pezoderange: _tabContext.data?.pezoderange
          ? (
            _tabContext.data.pezoderange.some(pezode => pezode.id === newRange.id)
              ? _tabContext.data.pezoderange.map(pezode =>
                pezode.id === newRange.id
                  ? newRange  // If pezode with the same ID exists, replace it
                  : pezode     // Otherwise, keep the original pezode
              )
              : [..._tabContext.data.pezoderange, newRange]  // If no pezode with the same ID exists, add new one
          )
          : [newRange],  // If there are no existing pezode, create an array with the new one
        selectedPezodeRange: null
      },
      isDirty: true
    });


    onSubmit(); // Close form after submit
  };

  //Use Effects
  useEffect(() => {
    const setFormSchema = () => {
      try {
        let _lookUpData = {};
        _lookUpData.outputUnitList = [];

        if (OutputUnitList.length) {
          _lookUpData.outputUnitList = OutputUnitList.map((item) => {
            return {
              id: item.UnitKey,
              label: item.UnitValue,
            };
          });
        }

        setFormData((prevstate) => ({
          ...prevstate,
          pezodeRangeSchema: getPezodeRangeSchema(_lookUpData, _formattedRange),
        }));

        spinnerCtx.setLoadingIndicator(false);

      } catch (err) {
        alert(err);
      }
    };

    spinnerCtx.setLoadingIndicator(true);
    if (OutputUnitList) {
      setFormSchema();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [OutputUnitList]);

  return (
    <FormContextProvider
      schema={formData.pezodeRangeSchema}
      defaultValues={defaultFormValues}
      appformdata={formData.appformdata}
    >
      <AppForm onSubmit={onPezodeRangeSubmit}>
        <DynamicFormContainer
          header={t("createPezode.pezodeRangeTab")}
          onCancel={onCancel}
          onSaveLabel={t("generic.save")}
        />
      </AppForm>
    </FormContextProvider>
  );
};

export default PezodeRangeCreate;
